import Loadable from '../../components/loadable';

const PosTaxRates = Loadable({
  loader: () => import('../../pages/pos/tax_rates/index'),
  type: 'block',
});

angular.module('gym').value('PosTaxRates', PosTaxRates);
